import { Component, OnInit, Renderer2 } from '@angular/core';
import { LoginService } from '@app/core/services/login/login.service';
import { LoaderService } from '../../core/services/loader/loader.service';
import { PopupService } from '../../shared/services/popup/popup.service';

@Component({
  selector: 'landing-app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class LandingHeaderComponent implements OnInit {

  constructor(private popupService: PopupService,
    private renderer2: Renderer2,
    private loader: LoaderService  ) {
  }

  ngOnInit() {
    var elem = document.getElementById('scrpt-wbflw');
    if(elem)
    elem.parentNode.removeChild(elem);
  
    this.loadWebflowScript();
  }
  opensignupformDialog(): void {
    this.popupService.openSignUp();
  }

  openloginFormDialog(): void {
    this.popupService.openLogin();
  }



  dynamicScripts = [
    'assets/js/webflow.js',
  ];

  //lets load the script of webflow, it is here as we want to load this on every page.
  loadWebflowScript() {
    for (let i = 0; i < this.dynamicScripts.length; i++) {
      const node = this.renderer2.createElement('script');
      node.src = this.dynamicScripts[i];
      node.type = 'text/javascript';
      node.async = false;
      node.charset = 'utf-8';
      node.id = 'scrpt-wbflw'
      document.getElementsByTagName('head')[0].appendChild(node);
    }
  }

}
